<template>
    <div class="page-languages">
        <page-corners/>
        <div>
            <h2>Les dates clef de la période de</h2>
            <h1>Colonisation</h1>
            <Languages/>
        </div>
    </div>
</template>

<script>
    import Languages from "shared-src/langues/languages";
    import PageCorners from "shared-src/decoration/PageCorners";
    export default {
        name: "PageLanguages",
        components: {PageCorners, Languages},
        methods:{
        }
    }
</script>

<style lang="less">
    .page-languages{
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
        h1,h2{
            line-height: 1.5;
            margin: 0;
            font-weight: normal;
        }
        h1{
            font-size: 4.8vw;
        }
        .languages{
            margin-top: 3vw;
        }


    }
</style>